// ====== plugin import ======= //
import React from 'react'
import { Link } from 'react-router-dom';

// ====== component import ========= //
import { SectionHeader_1, Card_3 } from '../../../component/landingComponent';

const FullyManaged = () => {
    return (
        <div className="container container-large">
            <div className="section-header text-center">
                <SectionHeader_1
                    title={`Fully Managed`}
                    subTitle={`For enterprises who need fully managed AI Agents`}
                    text={`We will develop, and fully manage AI Agents for you, relieving your teams from development and in-house  maintenance. You can focus on your core business, while letting our expertise and platform work for you.`}
                />
            </div>
            <div className="sec-3-wrapper-box">
                <div className="sec-3-features-wrapper">
                    <Link to ="/fully-managed#how-its-works">
                        <Card_3
                            icon={`/assets/img/tvicon/how-it-works.png`}
                            title={`How it works?`}
                            subTitle={`Just specify what the Virtual Agent should do.`}
                        />
                    </Link>
                    <Link to="/fully-managed#low-tco">
                        <Card_3
                            icon={`/assets/img/tvicon/no-tech-background.png`}
                            title={`Low TCO`}
                            subTitle={`No technical resources required. No band width.`}
                        />
                    </Link>
                    <Link to="truvoice-platform#pricing">
                        <Card_3
                            icon={`/assets/img/tvicon/tv-pricing.png`}
                            title={`Pricing`}
                            subTitle={`Usage based pricing`}
                        />
                    </Link>
                    <Link to="#">
                        <Card_3
                            icon={`/assets/img/tvicon/customization.png`}
                            title={`Customizations`}
                            subTitle={`API integrations for any application`}
                        />
                    </Link>
                </div>
            </div>
        </div>
    )
}

export {FullyManaged}